type Props = {
  size?: number;
  strokeWidth?: number;
  className?: string;
};

export function GroupCallIcon({ className }: Props) {
  return (
    <svg
      className={className}
      fill="currentColor"
      id="Layer_1"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
    >
      <path d="m16.278 8c.923 0 3.733 0 4.666 2.67.183.521-.092 1.092-.614 1.274-.508.18-1.092-.088-1.274-.614-.096-.686-1.113-1.454-3.056-1.33-.552 0-1-.447-1-1s.448-1 1-1zm-3.278-4c0-1.99 1.009-3 3-3s3 1.01 3 3-1.009 3-3 3-3-1.01-3-3zm2 0c0 .879.122 1 1 1s1-.121 1-1-.122-1-1-1-1 .121-1 1zm-8 5c0-.553-.448-1-1-1-3.411 0-5 1.589-5 5 0 .553.448 1 1 1s1-.447 1-1c0-2.299.701-3 3-3 .552 0 1-.447 1-1zm14.125 9.75c-.543 0-1.033.231-1.375.6-.073.079-.146.174-.31.212-.348.08-1.231-.522-1.856-1.147s-1.227-1.507-1.147-1.856c.038-.165.134-.237.212-.31.369-.342.6-.832.6-1.375 0-1.036-.84-1.875-1.875-1.875s-2.375.875-2.375 2.75c0 1.036 1.116 3.134 2.616 4.634s3.599 2.616 4.634 2.616c1.875 0 2.75-1.339 2.75-2.375s-.839-1.875-1.875-1.875zm-7.125-7.75c0-1.99-1.009-3-3-3s-3 1.01-3 3 1.009 3 3 3c.552 0 1-.447 1-1s-.448-1-1-1c-.878 0-1-.121-1-1s.122-1 1-1 1 .121 1 1c0 .553.448 1 1 1s1-.447 1-1zm-11-7c0-1.99 1.009-3 3-3s3 1.01 3 3-1.009 3-3 3-3-1.01-3-3zm2 0c0 .879.122 1 1 1s1-.121 1-1-.122-1-1-1-1 .121-1 1zm4.878 11.063c-2.61.318-3.878 1.934-3.878 4.937 0 .553.448 1 1 1s1-.447 1-1c0-2.264.745-2.784 2.121-2.952.548-.066.938-.565.872-1.113-.067-.548-.569-.947-1.114-.871z" />
    </svg>
  );
}
